import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import CareerContent from '../components/careers/CareerContent';
import CareerForm from '../components/careers/CareerForm';
import careersHero from '../assets/images/hero/careers.png';

const Careers = () => {
  return (
    <div>
      <SEO 
        title="Careers | Join Grace Super Market Team"
        description="Join the Grace Super Market team. Explore career opportunities in retail, management, and operations across our 39 stores in Chennai."
        keywords="Grace Super Market careers, retail jobs Chennai, supermarket jobs, retail careers"
        ogImage={careersHero}
        canonicalUrl={`${process.env.REACT_APP_CURRENT_URL}/careers`}
      />
      <HeroSection 
        title="Join Our Team" 
        description="Build Your Career with Grace Super Market"
        image={careersHero}
      />
      <section className="py-12">
        <div className="container mx-auto  px-6 md:px-20">
          <div className="flex flex-col md:flex-row gap-8 mb-10">
            <CareerContent />
            <CareerForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;